import React from "react"
import { graphql } from "gatsby"
import StructuredText from "../custom-structured-text-renderer"

const ArticleContent = ({ richContent }) => {
  return (
    <section className="article-content">
      <div className="article-content__inner">
        <div className="article-content__left"></div>
        <div className="article-content__right">
          {richContent && <StructuredText data={richContent} />}
        </div>
      </div>
    </section>
  )
}

export default ArticleContent

export const query = graphql`
  fragment ArticleContentProps on DatoCmsArticleContent {
    ... on DatoCmsArticleContent {
      id
      richContent {
        value
      }
    }
  }
`